// Format phone number to US format (xxx) xxx-xxxx
export function formatPhoneUS(phone) {
  if (!phone) return '';
  
  // Remove all non-digits
  const digits = phone.replace(/\D/g, '');
  
  // Handle different lengths
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else if (digits.length === 11 && digits[0] === '1') {
    // Handle +1 country code
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  } else if (digits.length === 7) {
    // Local number without area code
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  
  // Return original if can't format
  return phone;
}

// Format phone as user types (for input masking)
export function formatPhoneInput(value) {
  // Remove all non-digits
  const digits = value.replace(/\D/g, '');
  
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

// Parse formatted phone to digits only
export function parsePhone(phone) {
  return phone.replace(/\D/g, '');
}

// Format ZIP code as user types (US format: XXXXX or XXXXX-XXXX)
export function formatZipInput(value) {
  // Remove all non-digits
  const digits = value.replace(/\D/g, '');
  
  if (digits.length === 0) return '';
  if (digits.length <= 5) return digits;
  // Format as XXXXX-XXXX for ZIP+4
  return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
}

// Format ZIP code for display
export function formatZipUS(zip) {
  if (!zip) return '';
  
  const digits = zip.replace(/\D/g, '');
  
  if (digits.length === 5) {
    return digits;
  } else if (digits.length === 9) {
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }
  
  return zip;
}
